module.exports = __webpack_public_path__ + "static/media/2.ca2b91b0.JPG";